import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {},
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/available-drivers-map/available-drivers-map-styles.js